
const React = require('react');
const { lazy } = require("/home/runner/work/nostalgie.dev/nostalgie.dev/node_modules/nostalgie/lazy/index.js");

const Suspense = process.env.NOSTALGIE_BUILD_TARGET === 'browser' ? React.Suspense : (props) => React.Children.only(props.children);

module.exports = {
  ...React,
  lazy,
  Suspense,
};
                